import { indoorServiceAtom } from "@/atoms/indoor";
import merchantAccessStateAtom from "@/atoms/merchant-access";
import { minuteNowAtom, tenantTimezoneAtom } from "@/atoms/tenant-clock";
import { getNextOpeningMessage } from "@/lib/get-next-opening";
import { isNowInSchedule } from "@/lib/schedule";
import { useAtomValue } from "jotai";
import { useMemo } from "react";

/**
 * Status for the INDOOR service (QR menu). Independent from useMerchantStatus
 * which is scoped to DELIVERY.
 */
export function useIndoorMerchantStatus() {
  const indoorService = useAtomValue(indoorServiceAtom);
  const accessState = useAtomValue(merchantAccessStateAtom);
  const timeZone = useAtomValue(tenantTimezoneAtom);
  const now = useAtomValue(minuteNowAtom);

  const accountSuspended = accessState === "SUSPENDED";

  const merchantIsOpen = useMemo(() => {
    if (accountSuspended) return false;
    if (!indoorService?.serviceHours?.weekHours) return false;
    if (indoorService.status !== "AVAILABLE") return false;
    return isNowInSchedule(indoorService.serviceHours.weekHours, now, timeZone);
  }, [accountSuspended, indoorService, now, timeZone]);

  const nextOpeningMessage = useMemo(() => {
    if (accountSuspended) return null;
    if (merchantIsOpen) return null;
    if (!indoorService?.serviceHours?.weekHours) return null;
    return getNextOpeningMessage(indoorService.serviceHours.weekHours, now, timeZone);
  }, [accountSuspended, merchantIsOpen, indoorService, now, timeZone]);

  return { merchantIsOpen, nextOpeningMessage, accountSuspended };
}
